module.exports = __webpack_public_path__ + "img/VN-flag.158c1543.svg";